import React from 'react';

class JPconfirmModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    handleSubmit(e) {
        this.props.callBack(this.props.action);
        this.modalClose();
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }
    renderBody() {
        let body;
        if(this.props.action == 0){
            body = "Are you sure to send email to employee for justification?";
        }else if (this.props.action == 1){
            body = "Please confirm that all mileage claims are approved";
        }else{
            body = "Are you sure to reject the mileage claim?";
        }
    
        return (body);
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" >
                        {this.renderBody()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning" onClick={this.handleSubmit}>Ok</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default JPconfirmModal;


// WEBPACK FOOTER //
// ./app/components/jpComponents/jpConfirmModal.js